module.exports = __webpack_public_path__ + "img/yongcar.e9a58857.png";